  <mat-checkbox *ngIf="!readonly" [formControl]="control" [required]="true">{{attribute.name}}
  </mat-checkbox>
